/**
 * Admin Bible section-headings queries — list / update headings and
 * triage the user-submitted heading-flag queue.
 */
import { supabase } from '@/lib/supabase'

/** List every heading for a book with open-flag counts. */
export async function adminListSectionHeadings(book) {
  const { data, error } = await supabase.rpc('admin_list_section_headings', { p_book: book })
  if (error) throw error
  return data || []
}

/** Update a heading's text + paragraph_breaks. Sets edited_by_admin=true. */
export async function adminUpdateSectionHeading({ id, heading, paragraphBreaks }) {
  const { error } = await supabase.rpc('admin_update_section_heading', {
    p_id: id,
    p_heading: heading,
    p_paragraph_breaks: paragraphBreaks ?? [],
  })
  if (error) throw error
}

/** List all open heading flags with full context for triage. */
export async function adminListOpenHeadingFlags() {
  const { data, error } = await supabase.rpc('admin_list_open_heading_flags')
  if (error) throw error
  return data || []
}

/** Mark a flag as resolved or dismissed. */
export async function adminResolveHeadingFlag(flagId, newStatus) {
  const { error } = await supabase.rpc('admin_resolve_heading_flag', {
    p_flag_id: flagId,
    p_new_status: newStatus,
  })
  if (error) throw error
}
